<template>
    <div :class="[noSpace ? '' : '_card_hl826_1']">
        <div class="_main_hl826_24">
            <div class="_image_hl826_28" style="margin-right: 1.5rem">
                <slot :name="'logo'" />
            </div>
            <div class="_content_hl826_31">
                <div class="_right_hl826_37" :style="[biggerRight ? 'width: max-content' : '']">
                    <slot :name="'right-' + 1" />
                </div>
                <div class="_left_hl826_41">
                    <slot :name="'left-' + 1" />
                </div>
                <div class="_right_hl826_37" :style="[biggerRight ? 'width: max-content' : '']">
                    <slot :name="'right-' + 2" />
                </div>
                <div class="_left_hl826_41">
                    <slot :name="'left-' + 2" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ShortDisplayCard',
    props: {
        noSpace: {
            default: false
        },
        biggerRight: {
            default: false
        }
    }
}
</script>
